module.exports = __webpack_public_path__ + "media/books/Books-Focus-1-02b9b987.png";